import React, { useEffect, useRef, useState } from 'react';
import {
    Box,
    Text,
    Flex,
    IconButton,
    Grid,
    Heading,
    GridItem,
    useColorModeValue,
    useColorMode,
} from '@chakra-ui/react';
import { useBreakpointValue } from '@chakra-ui/react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ChevronUpIcon, ChevronDownIcon } from '@chakra-ui/icons';
import Boxx from '../../components/common/boxhome/boxx';
import Footer from "../../components/footer/footer";
import Lottie from 'lottie-react';
import Ai1 from '../../lotti-file/awaraness/metafacebook.json';
import Ai2 from '../../lotti-file/awaraness/googleads.json';
import Ai3 from '../../lotti-file/awaraness/youtube.json';
import Ai4 from '../../lotti-file/awaraness/linkdin.json';
import Ai5 from '../../lotti-file/awaraness/Influencermarketing.json';
import Ai6 from '../../lotti-file/awaraness/metawhite.json';
import Ai7 from '../../lotti-file/awaraness/googlewhite.json';
import Ai8 from '../../lotti-file/awaraness/youtubewhite.json';
import Ai9 from '../../lotti-file/awaraness/linkdinwhite.json';
import Ai10 from '../../lotti-file/awaraness/influncerwhite.json';


const solutions = [
    { title: "Digital Branding Solutions", path: "/digitalbranding" },
    { title: "Awareness Growth Solutions", path: "/awarenesssoutions" },
    { title: "Revenue Growth Solutions", path: "/revenuegrowth" },
    { title: "Social Media Management", path: "/socialmedia" },
    { title: "SEO", path: "/seo" },
    { title: "Performance Marketing", path: "/performancemarketing" },
];


const services = [
    { title: <Text as="span">'Meta, Facebook,<Text as="span" color="#FE3A3A"> Instagram Ads</Text> </Text>, description: 'Data-driven campaigns to maximize reach, boost brand awareness, and drive engagement across social platforms.', animationDataLight: Ai6, animationDataDark: Ai1, },
    { title: <Text as="span">Google <Text as="span" color="#FE3A3A">Ads</Text> </Text>, description: 'Strategic paid search campaigns that connect your brand with potential customers when they’re actively searching for your products.', animationDataLight: Ai7, animationDataDark: Ai2, },
    { title: <Text as="span">YouTube <Text as="span" color="#FE3A3A">Ads</Text> </Text>, description: 'High-impact video advertising to tell your brand’s story and capture your audience’s attention.', animationDataLight: Ai8, animationDataDark: Ai3, },
    { title: <Text as="span">LinkedIn <Text as="span" color="#FE3A3A">Ads</Text></Text>, description: 'Engage professionals with targeted ads that increase brand awareness in business and networking communities.', animationDataLight: Ai9, animationDataDark: Ai4, },
    { title: <Text as="span">Influencer <Text as="span" color="#FE3A3A">Marketing</Text></Text>, description: 'Collaborate with influencers to expand your reach and build credibility within your niche.', animationDataLight: Ai10, animationDataDark: Ai5, },
]
const Digitalbranding: React.FC = () => {
    const navigate = useNavigate(); 
    const scrollRef = useRef<HTMLDivElement>(null);
    const pathData = useBreakpointValue({
        base: "M0 10 Q75 0 200 10",
        md: "M0 20 Q150 0 300 20"
    });

    const { colorMode } = useColorMode();
    const [loading, setLoading] = useState(false);
    const location = useLocation();

    const selectedIndex = solutions.findIndex((solution) => solution.path === location.pathname);
    const itemRefs = useRef<(HTMLDivElement | null)[]>([]);

    const handleSolutionClick = (index: number, path: string) => {
        setLoading(true);

        setTimeout(() => {
            navigate(path);
        }, 500);
    };

    useEffect(() => {
        if (selectedIndex !== null && itemRefs.current[selectedIndex]) {
            itemRefs.current[selectedIndex]?.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'center',
            });
        }
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    }, [selectedIndex, location.pathname]);

    const gridTemplateColumns = useBreakpointValue({
        base: '1fr',
        md: 'repeat(2, 1fr)'
    });
    const bg = useColorModeValue('white', '#1C1C1C')
    const color = useColorModeValue('#FFFFF', 'white')
    const textColor = useColorModeValue('#1C1C1C', 'white');
    const selectedTextColor = 'white';

    return (
        <Grid
            bg={bg}
            templateColumns="1fr"
            gap={4}
            p={4}
            width="full"
            marginTop="auto"
        >
            <Box textAlign="center" mt={{ base: "10px", md: "20px" }} position="relative">
                <Text
                    fontSize={{ base: "12px", md: "28px" }}
                    lineHeight="36px"
                    fontWeight="400"
                >
                    <span style={{ fontFamily: "'Gilroy-Regular', sans-serif" }} color={color}>
                        Service /{' '}
                    </span>
                    <span style={{ color: '#FE3A3A', fontFamily: "'Cags Hetonal', sans-serif" }}>
                        Awareness Growth Solutions
                    </span>
                </Text>

                <Box mt="10px" display="inline-block" ml={{ base: '90px', md: '120px' }}>
                    <svg width="100%" height="auto" viewBox="0 0 300 40">
                        <path
                            d={pathData}
                            fill="none"
                            stroke={colorMode === 'light' ? 'black' : 'silver'}
                            strokeWidth="2"
                        />
                    </svg>
                </Box>
            </Box>

            <Box textAlign="center" mt={{ base: "10px", md: "20px" }} position="relative">
                <Text
                    fontSize={{ base: "32px", md: "64px" }}
                    lineHeight={{ base: "40px", md: "78px" }}
                    fontWeight="400"
                >
                    <span style={{ fontFamily: "'Gilroy-Regular', sans-serif" }} color={color}>
                        What {' '}
                    </span>
                    <span style={{ color: '#FE3A3A', fontFamily: "'Cags Hetonal', sans-serif" }}>
                        we offer
                    </span>
                </Text>
            </Box>

            <Box
                ref={scrollRef}
                overflowX="auto"
                whiteSpace="nowrap"
                flexGrow={1}
                p={1}
                width="full"
                sx={{
                    '::-webkit-scrollbar': { display: 'none' },
                    msOverflowStyle: 'none',
                    scrollbarWidth: 'none',
                }}
            >
                <Flex
                    width="100%"
                    gap={6}
                    flexDirection="row"
                    overflowX="auto"
                    padding="10px"
                    maxWidth="100%"
                    sx={{
                        '::-webkit-scrollbar': {
                            display: 'none',
                        },
                        msOverflowStyle: 'none',
                        scrollbarWidth: 'none',
                    }}
                >
                    {solutions.map((solution, index) => (
                        <Box
                            key={solution.title}
                            ref={(el) => itemRefs.current[index] = el} 
                            onClick={() => handleSolutionClick(index, solution.path)}
                            borderRadius="md"
                            padding="10px"
                            fontFamily="'Gilroy-Regular', sans-serif"
                            cursor="pointer"
                            transition="background-color 0.3s"
                            bg={selectedIndex === index ? 'red.500' : 'transparent'}
                            flexShrink={0} 
                        >
                            <Text
                                fontSize={{ base: "20px", md: "28px" }}
                                color={selectedIndex === index ? selectedTextColor : textColor}
                            >
                                {solution.title}
                            </Text>
                        </Box>
                    ))}
                </Flex>
            </Box>

            <Box
                height={{ base: "50vh", md: "100vh" }}
                width="100%"
                maxWidth="auto"
                bg="#000000"
                backgroundImage="url('/assets/images/svg/awarenesspage.jpg')"
                backgroundSize="cover"
                backgroundPosition="center"
                display="flex"
                alignItems="center"
                justifyContent="center"
                borderRadius="20px"
                mt={4}
                opacity={1}
            >
             
            </Box>

            <Box textAlign="left" mt="10px">
                <Text fontSize={{ base: '28px', md: '52px' }} fontFamily="'Gilroy-SemiBold', sans-serif" color={color}>
                    Descriptions
                </Text>
                <Text
                    textAlign="justify" 
                    fontSize={{ base: '16px', md: '28px' }}
                    lineHeight={{ base: '24px', md: '36px' }}
                    fontWeight="400"
                    fontFamily="'Gilroy-Regular', sans-serif"
                    mt="20px"
                    color={color}
                    letterSpacing={{ base: '0.5px' }}

                >
                    Your brand’s visibility is crucial to success. With RareToss’s Awareness Growth Solutions, we implement targeted campaigns that increase your brand’s reach and awareness across multiple platforms. Whether through paid ads or influencer partnerships, we make sure your message resonates with your ideal audience.
                </Text>
            </Box>

            <Grid
                mt="30px"
                templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)' }}
                gap={{ base: 4, md: 6 }}
                p={{ base: 2, md: 4 }}
                maxWidth="100%"
                height="auto"
                mx="auto"
                overflowX="hidden"
            >
                {services.map((service, index) => (
                    <GridItem
                        key={index}
                        position="relative"
                        display="flex"
                        justifyContent="center"
                        height="100%" 
                    >
                        <Box
                            borderRadius="md"
                            p={4}
                            borderColor="gray.600"
                            mb={4}
                            textAlign="center"
                            mx="auto"
                            width="100%"
                            display="flex"
                            flexDirection="column"
                            justifyContent="space-between"
                            height="100%" 
                        >
                            {/* Lottie Box */}
                            <Box
                                mb={{ base: 2, md: -5 }}
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                ml={{ md: "-10px" }}
                                width={{ base: '100px', md: '255px' }}
                                height={{ base: '60px', md: '162px' }}
                                mx="auto"
                                order={{ base: 0, md: -1 }}
                            >
                                <Lottie
                                    animationData={colorMode === 'light' ? service.animationDataLight : service.animationDataDark}
                                    loop={true}
                                />
                            </Box>

                            {/* Title and Description */}
                            <Box display="flex" flexDirection="column" alignItems={{ base: 'center', md: 'flex-start' }} mt={4}>
                                <Text
                                    fontSize={{ base: '16px', md: '40px' }}
                                    fontWeight="400"
                                    color={colorMode === 'light' ? 'black' : 'white'}
                                    whiteSpace="nowrap"
                                    overflow="visible"
                                    fontFamily="'Gilroy-SemiBold', sans-serif"
                                    textOverflow="ellipsis"
                                    maxWidth="100%"
                                    textAlign="center"
                                    mt={{ base: '0', md: '0' }}
                                >
                                    {service.title}
                                </Text>
                                <Text
                                    color={colorMode === 'light' ? 'black' : 'white'}
                                    fontSize={{ base: '14px', md: '25px' }}
                                    mt={1}
                                    textAlign="justify"
                                    fontFamily="'Gilroy-SemiBold', sans-serif"
                                >
                                    {service.description}
                                </Text>
                            </Box>

                            {/* Gradient Border (Bottom line) */}
                            <Box
                                mt={4}
                                border="1px solid"
                                sx={{
                                    borderImageSource:
                                        colorMode === 'light'
                                            ? 'linear-gradient(270deg, #FFFFFF 0%, #C92E2E 50%, #FFFFFF 100%)'
                                            : 'linear-gradient(270deg, #1C1C1C 0%, #C92E2E 50%, #1C1C1C 100%)',
                                    borderImageSlice: 1,
                                }}
                            />
                        </Box>

                        {/* Gradient Divider Between Items on Larger Screens */}
                        {index % 2 === 0 && index < services.length - 1 && (
                            <Box
                                display={{ base: 'none', md: 'block' }}
                                position="absolute"
                                top={0}
                                bottom={0}
                                right={0}
                                width="1px"
                                background={
                                    colorMode === 'light'
                                        ? 'linear-gradient(473deg, #FFFFFF 0%, #C92E2E 50%, #FFFFFF 100%)'
                                        : 'linear-gradient(473deg, #1C1C1C 0%, #C92E2E 50%, #1C1C1C 100%)'
                                }
                                height="100%"
                                transform="translateX(50%)"
                            />
                        )}
                    </GridItem>
                ))}
            </Grid>




            {/* BrandingInfoList component added here */}

            <Box mt={{ base: "50px", md: "100px" }} textAlign="center">
                <Text fontFamily="'Gilroy-Regular', sans-serif" fontSize={{ base: "12px", md: "28px" }} color={color}>
                    Frequently Asked Questions
                </Text>

                <Box textAlign="center" mt={{ base: '30px', md: '50px' }}>
                    <Heading
                        fontFamily="'Gilroy-SemiBold', sans-serif"
                        fontSize={{ base: "32px", md: "64px" }}  
                        fontWeight="400"
                        lineHeight={{ base: "40px", md: "78px" }} 
                        letterSpacing="-0.25px"
                        color={color}
                    >
                        <Text as="span" color="#FE3A3A" fontFamily="'Cags Hetonal', sans-serif"> Questions?</Text>
                    </Heading>

                    <Text
                        fontFamily="'Cags Hetonal', sans-serif"
                        fontSize={{ base: "32px", md: "64px" }} 
                        fontWeight="400"
                        lineHeight={{ base: "40px", md: "78px" }}
                        letterSpacing="-0.25px"
                        mt="10px"
                    >
                        <Text as="span" color={color}>Your </Text>
                        <Text as="span" color="#FE3A3A" fontFamily="'Cags Hetonal', sans-serif">Answers </Text>
                        <Text as="span" color={color} fontFamily="'Gilroy-SemiBold', sans-serif">are here  </Text>
                    </Text>
                </Box>
            </Box>
            <BrandingInfoList />
            <Text color={color} mt={{ base: "40px", md: "100px" }} fontSize={{ base: '12px', md: '28px' }} textAlign='center' fontFamily="'Gilroy-Medium', sans-serif">
                Get In Touch
            </Text>            <Boxx />
            <Footer />

        </Grid>

    );
};

interface BrandingInfoProps {
    title: string;
    content: string;
}

const BrandingInfo: React.FC<BrandingInfoProps> = ({ title, content }) => {
    const [isOpen, setIsOpen] = useState(false);
    const bg = useColorModeValue('white', '#1C1C1C')
    const color = useColorModeValue('#FFFFF', 'white')
    return (
        <Box
            bg={bg}
            maxW="auto"
            borderRadius={{ base: '10px', md: '20px' }}
            color={color}
            border={isOpen ? '1px solid #FE3A3A' : 'none'}
            overflow="hidden"
            mt={{ base: '10px', md: '14px' }} 
        >
            <Box
                display="flex"
                justifyContent="space-between"
                onClick={() => setIsOpen(!isOpen)}
                cursor="pointer"
                alignItems="center"
                border={isOpen ? '2px solid #FE3A3A' : 'none'}
                borderRadius="md"
                p={{ base: '10px', md: '20px' }} 
                backgroundColor={isOpen ? '#FE3A3A' : 'transparent'}
            >
                <Text
                    fontFamily="'Gilroy-SemiBold', sans-serif"
                    fontWeight="400"
                    fontSize={{ base: "16px", md: "32px" }} 
                    lineHeight={{ base: "24px", md: "40px" }}
                >
                    {title}
                </Text>
                <IconButton
                    aria-label={isOpen ? "Collapse" : "Expand"}
                    icon={isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
                    fontSize={{ base: "24px", md: "30px" }}
                    variant="outline"
                    color={color}
                    borderColor="white"
                    _hover={{ bg: 'transparent' }}
                    p={{ base: 1, md: 1 }}
                />
            </Box>
            <Box p={isOpen ? 4 : 0} maxH={isOpen ? 'auto' : '0'} transition="max-height 0.2s ease-out">
                <Text
                    fontFamily="'Gilroy-Regular', sans-serif"
                    fontSize={{ base: "16px", md: "28px" }} 
                    lineHeight={{ base: '24px', md: '36px' }} 
                >
                    {content}
                </Text>
            </Box>
        </Box>
    );
};

const BrandingInfoList: React.FC = () => {
    return (
        <Box>
            <BrandingInfo title="How will awareness growth campaigns help my business?" content="Awareness campaigns increase your brand’s visibility, making potential customers aware of your products or services. In a fast-growing market like India, this visibility helps you capture attention and grow your business." />
            <BrandingInfo title="Which platforms are best for increasing brand awareness in India? " content="Platforms like Meta (Facebook & Instagram), Google, and YouTube work effectively for most businesses in India. For B2B and professional audiences, LinkedIn is a great choice." />
            <BrandingInfo title="What budget is required for an awareness campaign?" content="The budget depends on your goals and the platforms you choose. We offer flexible options to suit different budgets, from smaller local campaigns to larger, nationwide strategies." />
            <BrandingInfo title="How do you measure the success of an awareness campaign? " content="We track metrics like impressions, reach, engagement, and traffic to assess the impact of awareness campaigns. Detailed reports are provided regularly to measure success." />
            <BrandingInfo title="As a startup, how can I build awareness with a limited budget?" content="For startups, we focus on cost-effective methods like organic social media growth, influencer marketing, and highly targeted paid ads. These strategies ensure maximum reach without overspending." />

        </Box>

    );
};

export default Digitalbranding;
